import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { computeThemeClassNames, } from "../utils/utils";
import styles from "./logo.module.css";
var DEFAULT_SIZE = "md";
var DEFAULT_MODE = "color";
var DEFAULT_DARK_MODE = "light";
export function ThemedLogo(_a) {
    var _b;
    var className = _a.className, imgClassName = _a.imgClassName, children = _a.children, _c = _a.theme, theme = _c === void 0 ? "primary" : _c, _d = _a.size, size = _d === void 0 ? DEFAULT_SIZE : _d, logo = _a.logo, light = _a.light, dark = _a.dark, darkTheme = _a.darkTheme, _e = _a.mode, mode = _e === void 0 ? DEFAULT_MODE : _e, _f = _a.darkMode, darkMode = _f === void 0 ? DEFAULT_DARK_MODE : _f, variant = _a.variant, inline = _a.inline, alt = _a.alt;
    return (_jsxs("div", { className: classNames(styles["container"], className, computeThemeClassNames({}), (_b = {},
            _b[styles[size]] = size !== DEFAULT_SIZE,
            _b[styles["mode__".concat(mode)]] = mode !== DEFAULT_MODE,
            _b[styles["dark-mode__".concat(darkMode)]] = darkMode !== DEFAULT_DARK_MODE,
            _b[styles["inline"]] = !!inline,
            _b)), children: [createLogo(logo), createLogo(light, "light"), createLogo(dark, "dark")] }));
    function createLogo(logo, type) {
        if (type === void 0) { type = "color"; }
        return logo ? (_jsx("img", { className: classNames(styles["img"], styles[type], imgClassName), 
            /*width={logo.width}
             height={logo.height}*/
            src: logo.src, style: {
                aspectRatio: "".concat(logo === null || logo === void 0 ? void 0 : logo.width, " / ").concat(logo === null || logo === void 0 ? void 0 : logo.height),
            }, alt: alt })) : null;
    }
}
